import { useForm, UseFormReturnType } from '@mantine/form';

import { CapturedChangeConfig } from '../../../../../../AthletePackageCreateForm';
import { ChangeTiming, ReservationChoice } from '../changeModalSteps';

export type { CapturedChangeConfig };

export interface ChangeFormValues {
  timing: ChangeTiming | null;
  reservationChoice: ReservationChoice | null;
  captured: CapturedChangeConfig | null;
}

export type ChangeForm = UseFormReturnType<ChangeFormValues>;

const initialValues: ChangeFormValues = {
  timing: null,
  reservationChoice: null,
  captured: null,
};

export default function useChangeForm(): ChangeForm {
  return useForm<ChangeFormValues>({
    initialValues,
    validate: {
      timing: value => (value === null ? 'Please choose when the change should apply' : null),
    },
  });
}
